










































































import {Vue, Component} from 'vue-property-decorator';
import {getCurrency} from '@/utils/commonUtils';
@Component({})
export default class NaverPayGuide extends Vue {
	private NAVERPAY_GUIDE_KEY = {
		TITLE: 'TITLE',
		NAVERPAY_LIMIT: 'NAVERPAY_LIMIT',
		CHECK_LIMIT_PRODUCTS: 'CHECK_LIMIT_PRODUCTS',
    NAVER_PAY_TOOLTIP_SUB_TITLE: 'NAVER_PAY_TOOLTIP_SUB_TITLE',
    NAVER_PAY_TOOLTIP_NOTICE_ORDER_TYPE: 'NAVER_PAY_TOOLTIP_NOTICE_ORDER_TYPE',
    NAVER_PAY_TOOLTIP_NOTICE_PAYMENT_TYPE: 'NAVER_PAY_TOOLTIP_NOTICE_PAYMENT_TYPE',
    NAVER_PAY_TOOLTIP_NOTICE_ORDER_TYPE_DESC: 'NAVER_PAY_TOOLTIP_NOTICE_ORDER_TYPE_DESC',
    NAVER_PAY_TOOLTIP_NOTICE_ORDER_TYPE_DESC2: 'NAVER_PAY_TOOLTIP_NOTICE_ORDER_TYPE_DESC2',
    SERVICE_PRODUCT: 'SERVICE_PRODUCT',
    NAVER_PAY_TOOLTIP_NOTICE_PAYMENT_TYPE_DESC: 'NAVER_PAY_TOOLTIP_NOTICE_PAYMENT_TYPE_DESC',
		EG: 'EG',
		GUIDE_HEADER_1: 'GUIDE_HEADER_1',
		GUIDE_HEADER_2: 'GUIDE_HEADER_2',
		GUIDE_HEADER_3: 'GUIDE_HEADER_3',
		GUIDE_HEADER_4: 'GUIDE_HEADER_4',
		WON: 'WON',
		POSSIBLE: 'POSSIBLE',
		NOT_POSSIBLE: 'NOT_POSSIBLE',
		DETAIL_INFO_1: 'DETAIL_INFO_1',
		DETAIL_INFO_2: 'DETAIL_INFO_2',
		DETAIL_INFO_3: 'DETAIL_INFO_3'
	}
	private convertToI18n(key): string {
		return this.$t(`PRODUCT_NAVERPAY_GUIDE_${key}`).toString();
	}
	
	private convertNumberToCurrency(number: number): string {
		return `${getCurrency(number)}${this.convertToI18n(this.NAVERPAY_GUIDE_KEY.WON)}`;
	}
}
